import type { ItemKind } from "../../../api/content/reviewDecoders";

/**
 * What can be made new from the Workflows section (AU-7, F37): each is prepared in the
 * Thread view, by hand in its form where it has one or with the agent.
 * `authoring.library.new.<key>` names each.
 */
export const NEW_ITEMS = [
  { key: "workflows", kind: "workflow" },
  { key: "steps", kind: "step" },
  { key: "prompts", kind: "prompt" },
  { key: "tools", kind: "tool" },
  { key: "skills", kind: "skill" },
  { key: "artifacts", kind: "artifact" },
  { key: "labelLists", kind: "label_list" },
] as const satisfies readonly { readonly key: string; readonly kind: ItemKind }[];
